import { Component } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';
import { HistoryService } from '../services/history.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { LazyLoadEvent } from 'primeng/components/common/api';
import { FilterMetadata } from 'primeng/components/common/api';


import { FileService } from './../../shared/services/file.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { CONFIGURATION } from '../../shared/configuration/configuration';

import { StorageService } from '../../shared/services/storage.service';
import * as moment from 'moment';
declare var require: any
const FileSaver = require('file-saver');
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';
import { NativeDateAdapter, DateAdapter, MD_DATE_FORMATS } from "@angular/material";//Added by Anjaiah
import { AdminService } from 'app/admin/services/admin.service';

//Added by Anjaiah
export class AppDateAdapter extends NativeDateAdapter {

    format(date: Date, displayFormat: Object): string {
        if (displayFormat == "input") {
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();
            return this._to2digit(day) + '/' + this._to2digit(month) + '/' + year;
        } else {
            return date.toDateString();
        }
    }

    private _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }
}

export const APP_DATE_FORMATS =
{
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
    },
    display: {
        // dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
}
@Component({
    selector: 'customer-history',
    templateUrl: 'customer-history.component.html',
    //Added by Anjaiah
    providers: [
        {
            provide: DateAdapter, useClass: AppDateAdapter
        },
        {
            provide: MD_DATE_FORMATS, useValue: APP_DATE_FORMATS
        }
    ]
})
export class CustomerHistoryComponent {

    totalPlantmapRecords: number;
    totalNCERecords: number;

    vPageSize: number = STATIC_VALUE.TABLE.PAGE_SIZE;

    vLoadingPlant: boolean = false;
    vLoadingNCE: boolean = false;

    // vPlantRequestID: string = '';
    vPlantStatus: string = '';

    // vNCERequestID: string = '';
    vNCEStatus: string = '';

    resettedPlantTable: number = 0;
    resettedNceTable: number = 0;

    vPlantSearchBy: string = '';
    vPlantFilterBy: string = '';

    vPlantFromDateFilterBy: string = '';
    vPlantToDateFilterBy: string = '';
    //vPlantDate: Date;
    vPlantFromDate: Date;
    vPlantToDate: Date;

    vNCESearchBy: string = '';
    vNCEFilterBy: string = '';
    vNCEDate: Date;
    ascNumberSort: boolean;
    vDisableButton: boolean = false;
    //Kowsalya
    sortOrder: number;
    planstatus: string = '';

    vPlantLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        project_title: string,
        create_date: string,
        expiry_date: string,
        updated_date: string,
        location: string,
        a2_amount: string,
        status: string,
        trans_amount: string,
        check_status: string,
        registration_type: string,
        plant_map_s3_status: number,
        restricted_area: number,
        hourdiff: number

    }>;

    vNCELists: Array<{
        nce_record_id: number,
        nce_request_id: string,
        create_date: string,
        updated_date: string,
        location_earthwork: string,
        appointment_date: string,
        appointment_time: string,
        status: string
    }>;

    constructor(
        private _http: Http,
        private _historyService: HistoryService,
        private _layoutService: LayoutService,
        private _fileService: FileService,
        private _popupService: PopupService,
    ) {
    }


    ngOnInit() {
        this._layoutService.setCurrentPage('admin-user-account');

        this.vLoadingPlant = true;
        this._historyService.loadTotalCustomerPlant(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                this._historyService.loadPlantmap(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._historyService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._historyService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );

        // this.vLoadingNCE = true;
        // this._historyService.loadTotalCustomerNCE(this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
        //     (resolve) => {
        //         this._historyService.loadNCE(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
        //             (resolve) => {
        //                 this.vLoadingNCE = false;
        //                 this.totalNCERecords = this._historyService.getTotalCustomerNCE();
        //                 this.vNCELists = this._historyService.getNCEList();
        //             },
        //             (reject) => {
        //                 this.vLoadingNCE = false;
        //             }
        //         );
        //     },
        //     (reject) => {
        //         this.vLoadingNCE = false;
        //     }
        // );
        this._historyService.loadAllPlantStatus();

        this.vPlantSearchBy = this.getSearchBy('plantmap')[0].type;
    }

    getDetailPlantMap() {
        return this._historyService.getPlantmapDetail();
    }

    getPlantStatusList() {
        return this._historyService.getAllPlantStatus();
    }

    getNCEStatusList() {
        return this._historyService.getAllNCEStatus();
    }

    isLoading() {
        return this._historyService.isLoading();
    }

    getSearchBy(pType) {
        let data = [];
        for (let pm of STATIC_VALUE.SEARCH_BY.customer) {
            if (pm.plantValue !== '' && pType == 'plantmap') {
                data.push(pm);
            } else if (pm.nceValue !== '' && pType == 'nce') {
                data.push(pm);
            }
        }
        return data;
    }

    resetPlantFilter() {
        this.vPlantFilterBy = '';
        //this.vPlantDate = null;
        this.vPlantFromDate = null;
        this.vPlantToDate = null;
    }

    resetNCEFilter() {
        this.vNCEFilterBy = '';
        this.vNCEDate = null;
    }

    clearInputPlant() {
        this.resetPlantFilter();
        this.filterPlant();
    }

    resetPlant() {
        this.resetPlantFilter();
        this.vPlantSearchBy = this.getSearchBy('plantmap')[0].type;
        this.filterPlant();
    }

    clearInputNCE() {
        this.resetNCEFilter();
        this.filterNCE();
    }

    filterFromDatePlant() {
        this.vPlantFromDateFilterBy = this.vPlantFromDate.getFullYear() + '' + ("0" + (this.vPlantFromDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantFromDate.getDate()).slice(-2);
        //this.filterPlant();
    }

    filterToDatePlant() {
        console.log("hello", this.vPlantToDate);
        this.vPlantToDateFilterBy = this.vPlantToDate.getFullYear() + '' + ("0" + (this.vPlantToDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantToDate.getDate()).slice(-2);
        this.filterPlantDate();
        //this.vPlantToDate = moment(this.vPlantToDate).format('YYYY/MM/DD');
    }

    filterDateNCE() {
        this.vNCEFilterBy = this.vNCEDate.getFullYear() + '' + ("0" + (this.vNCEDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vNCEDate.getDate()).slice(-2);
        this.filterNCE();
    }

    refreshPlant() {

        if (this.vPlantSearchBy != 'applicationDate') {
            this.filterPlant();
        }
        else {
            if (this.vPlantFromDate != null && this.vPlantToDate) {
                this.filterPlantDate();

            }
            else {
                if (this.vPlantFromDate == null) {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
                }
                else {
                    this._popupService.openGeneralConfirmationPopup('Notice', 'You have not select the Purchase Date range. Please select the required From Date and To Date.', '', false, false);
                }
            }
        }
    }

    filterPlant() {
        this.vLoadingPlant = true;
        this.resettedPlantTable = 0;
        this._historyService.loadTotalCustomerPlant(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                this._historyService.loadPlantmap(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._historyService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._historyService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );
    }

    filterPlantDate() {
        this.vLoadingPlant = true;
        this.resettedPlantTable = 0;
        this._historyService.loadTotalCustomerPlantDate(this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus).then(
            (resolve) => {
                this._historyService.loadPlantmapDate(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, 0, "").then(
                    (resolve) => {
                        this.vLoadingPlant = false;
                        this.totalPlantmapRecords = this._historyService.getTotalCustomerPlantmap();
                        this.vPlantLists = this._historyService.getCustomerPlantList();
                    },
                    (reject) => {
                        this.vLoadingPlant = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingPlant = false;
            }
        );
    }

    filterNCE() {
        this.vLoadingNCE = true;
        this.resettedNceTable = 0;
        this._historyService.loadTotalCustomerNCE(this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                this._historyService.loadNCE(0, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
                    (resolve) => {
                        this.vLoadingNCE = false;
                        this.totalNCERecords = this._historyService.getTotalCustomerNCE();
                        this.vNCELists = this._historyService.getNCEList();
                    },
                    (reject) => {
                        this.vLoadingNCE = false;
                    }
                );
            },
            (reject) => {
                this.vLoadingNCE = false;
            }
        );
    }


    loadPlantmapLazy(event: LazyLoadEvent) {


        if (this.vLoadingPlant) {
            return;
        }

        let vPageNumber = event.first / this.vPageSize;
        this.vLoadingPlant = true;
        let sortfield = event.sortField;

        if (this.vPlantSearchBy != 'applicationDate') {
            this._historyService.loadPlantmap(vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, event.sortOrder, sortfield).then(
                (resolve) => {
                    this.vLoadingPlant = false;
                    this.vPlantLists = this._historyService.getCustomerPlantList();
                },
                (reject) => {
                    this.vLoadingPlant = false;
                }
            );
        }
        else {
            this._historyService.loadPlantmapDate(vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, event.sortOrder, sortfield).then(
                (resolve) => {
                    this.vLoadingPlant = false;
                    this.vPlantLists = this._historyService.getCustomerPlantList();
                },
                (reject) => {
                    this.vLoadingPlant = false;
                }
            );
        }
    }

    loadNCELazy(event: LazyLoadEvent) {

        if (this.vLoadingNCE) {
            return;
        }

        let vPageNumber = event.first / this.vPageSize;

        this.vLoadingNCE = true;
        this._historyService.loadNCE(vPageNumber, this.vPageSize, this.vNCESearchBy, this.vNCEFilterBy, this.vNCEStatus).then(
            (resolve) => {
                this.vLoadingNCE = false;
                this.vNCELists = this._historyService.getNCEList();
            },
            (reject) => {
                this.vLoadingNCE = false;
            }
        );
    }


    downloadInvoice(pPlantID) {
        // let path = CONFIGURATION.invoicePath[CONFIGURATION.modeEnv].PATH;
        // //const pdfUrl = './assets/Invoice/20200028.pdf';
        // const pdfUrl = path + pPlantID + '.pdf';
        // const pdfName = pPlantID;
        // FileSaver.saveAs(pdfUrl, pdfName);
        //this._fileService.getMiscSignedDownloadRequest('PlantMap_Invoice_'+pPlantID+'.pdf');
        //this._fileService.getMiscSignedDownloadRequest('PRP200602392_Invoice.pdf');
        this._historyService.downloadInvoiceFromDMS('PlantMap_Invoice_' + pPlantID + '.pdf');
    }

    downloadPlantmap(pPlantID) {
        // let path = CONFIGURATION.plantmapPath[CONFIGURATION.modeEnv].PATH;
        // //const pdfUrl = './assets/Invoice/20200028.pdf';
        // const pdfUrl = path + pPlantID + '.zip';
        // const pdfName = pPlantID;
        // FileSaver.saveAs(pdfUrl, pdfName);

        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_request_id === pPlantID);

            if (pmByPlantID.length > 0) {
                var test: any = pmByPlantID[0].plant_request_id;
                //this._fileService.getPlantMapSignedDownloadRequest('00099');
                this._fileService.getPlantMapSignedDownloadRequest(pmByPlantID[0].plant_request_id);

            }
        }

        //this._fileService.getMiscSignedDownloadRequest('Plantmap.zip');
    }



    viewPlantmap(pPlantID) {
        this._historyService.loadDetailPlantMap(pPlantID);
    }

    viewNCE(pNCEID) {
        this._historyService.loadNCEStatus(pNCEID);
    }

    enablePlantMapButton(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_request_id === pPlantID);
            let restricted_area = pmByPlantID[0].restricted_area;
            if (pmByPlantID.length > 0) {
                // removing the restricted condition as we need to allow both restricted and un-restricted maps download from MyOrder section.
                if ((pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED //'Payment received'
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.DONE)) {
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }

    checkDisableStatus(pPlantID: any) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_request_id === pPlantID);

            if (pmByPlantID.length > 0) {
                if (pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED //'Payment received'
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.DONE) {
                    //Anjaiah
                    var expireDateArray = pmByPlantID[0].expiry_date.split(" ", 2);
                    var currentDateArray = this._historyService.getExprityDateCheck().split(" ", 2);
                    let str = expireDateArray[0];
                    let str1 = currentDateArray[0];
                    //console.log("String date value ",str);
                    let time = expireDateArray[1];
                    let time1 = currentDateArray[1];
                    var slash = str.split("/", 3);
                    var slash1 = str1.split("/", 3);
                    let day = slash[1];
                    let month = slash[0];
                    let year = slash[2];
                    let re_str = day + "/" + month + "/" + year;
                    let day1 = slash1[1];
                    let month1 = slash1[0];
                    let year1 = slash1[2];
                    let re_str1 = day1 + "/" + month1 + "/" + year1;
                    //console.log('d1 d2',re_str,re_str1);
                    var expireDate = new Date(re_str);
                    var currentDate = new Date(re_str1);
                    //console.log('d1 d2',expireDate,currentDate);
                    if (pmByPlantID[0].plant_map_s3_status == 1 && expireDate >= currentDate)
                    //if(pmByPlantID[0].plant_map_s3_status == 1)
                    {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                //return false;
            }
            return false;
        }
        return false;
    }

    displayButton(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantstatus => plantstatus.plant_request_id === pPlantID);

            if (pmByPlantID.length > 0) {
                if (pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED //'Payment received'
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.DONE
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.PENDING_MAP_COLLECTION
                    || pmByPlantID[0].check_status == STATIC_VALUE.ALL_PLANT_STATUS.MAP_DELIVERED) {
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }
    //Kowsalya

    getrequestId(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantrecord => plantrecord.plant_request_id === pPlantID);
            // console.log('Hello');
            if (pmByPlantID.length > 0) {
                this.viewPlantmap(pmByPlantID[0].plant_record_id);
            }
        }
    }
    proceedToPay(pPlantID) {
        if (this.vPlantLists.length > 0) {
            let pmByPlantID = this.vPlantLists.filter(
                plantrecord => plantrecord.plant_request_id === pPlantID);

            if (pmByPlantID.length > 0) {
                this.viewPlantmap(pmByPlantID[0].plant_record_id);
            }
        }
    }
    downloadPlantmapFromDMS(arg: any) {
        let fileName = `PRP_${arg}.zip`;
        this._historyService.downloadZipFileFromDMS(fileName);
    }

    /* onNameSorting(e, dt){
                 //This break point is being hit now.
         if(!!e.order && e.order > 0){
             this.sortOrder = e.order;
             console.log("Line 435");
             console.log(e.order);
             console.log(this.vPlantLists);
             this.vPlantLists = this.vPlantLists.sort((a, b) => (a.plant_record_id < b.plant_record_id) ? -1 : 1);
             console.log(this.vPlantLists);
             //this.vPlantLists = this._historyService.getCustomerPlantList().sort((a, b) => (a.plant_record_id < b.plant_record_id) ? -1 : 1);
 
         }else{
             this.sortOrder = e.order;
             console.log("Line 439");
             console.log(this.vPlantLists);
             this.vPlantLists = this.vPlantLists
             .sort((a, b) => (a.plant_record_id > b.plant_record_id) ? -1 : 1);
             console.log(this.vPlantLists);;
         }
       }*/

    //Kowsalya
}




// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/history/components/customer-history.component.ts